<template>
  <div class="page-tabs">
    <template v-if="showBtnToolbar">
      <a
        href="javascript:"
        v-show="showPrev"
        class="btn-toolbar btn-toolbar-prev"
        @click="scrollLeft"
      ></a>
      <a
        href="javascript:"
        v-show="showNext"
        class="btn-toolbar btn-toolbar-next"
        @click="scrollRight"
      ></a>
    </template>
    <Scroll :scrollX="true" :scrollbar="false" ref="mainScroll">
      <div class="page-tabs-inner">
        <div
          ref="tabItem"
          class="item-tab"
          v-for="(item, index) in items"
          :key="item.res_id"
          :class="{
            active: activeIndex == index,
            disabled: activeIndex != index && disabled,
          }"
          @click="handleTab(index, item)"
        >
          {{ item.res_title }}
        </div>
      </div>
    </Scroll>
  </div>
</template>

<script>
import { debounce } from 'debounce'

export default {
  props: {
    items: {
      type: Array,
      default: [],
    },
    disabled: Boolean,
    activeIndex: {
      type: Number,
      default: 0,
    },
    change: Function,
  },
  data() {
    return {
      showBtnToolbar: false,
      index: 0,
    }
  },
  computed: {
    showPrev() {
      if (!this.$refs.mainScroll || !this.$refs.mainScroll.scroll) return false
      return this.$refs.mainScroll.scroll.x < 0
    },
    showNext() {
      if (!this.$refs.mainScroll || !this.$refs.mainScroll.scroll) return false
      return (
        this.$refs.mainScroll.scroll.x > this.$refs.mainScroll.scroll.maxScrollX
      )
    },
  },
  created() {
    this.index = this.activeIndex
  },
  mounted() {
    const tabInnerWidth = document.querySelector('.page-tabs-inner').clientWidth
    this.showBtnToolbar = tabInnerWidth > this.$refs.mainScroll.$el.clientWidth
  },

  methods: {
    handleTab(item, index) {
      this.change && this.change(item, index)
    },
    scrollLeft: debounce(function() {
      if (this.index == 0) {
        this.$refs.mainScroll.scrollTo(0, 0)
        return
      }
      this.index--
      let tabItems = this.$refs.tabItem
      this.$refs.mainScroll.scrollToElement(tabItems[this.index], 300)
    }, 50),
    scrollRight: debounce(function() {
      if (this.index >= this.items.length - 1) return
      this.index++
      let tabItems = this.$refs.tabItem
      this.$refs.mainScroll.scrollToElement(tabItems[this.index], 300)
    }, 50),
  },
}
</script>

<style lang="scss" scoped>
.page-tabs {
  position: relative;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(65, 152, 254, 0.1);
  z-index: 1;

  .btn-toolbar {
    position: absolute;
    top: 0;
    width: 28px;
    height: 45px;
    background: #ffffff;
    z-index: 2;
    &::after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: '';
      width: 14px;
      height: 19px;
      background-repeat: no-repeat;
      background-position: center;
    }
    &-prev {
      left: 0;
      box-shadow: 6px 0 10px 0 rgba(#000, 0.1);
      &::after {
        background-image: url(~@/assets/images/shrink-left.png);
      }
    }
    &-next {
      right: 0;
      box-shadow: -6px 0 10px 0 rgba(#000, 0.1);
      &::after {
        background-image: url(~@/assets/images/shrink-right.png);
      }
    }
  }
  .scroll {
    width: 100%;
  }
  &-inner {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .item-tab {
    position: relative;
    padding: 0 30px;
    height: 45px;
    flex: 0 0 auto;
    white-space: nowrap;
    font-size: 18px;
    color: #3f4651;
    line-height: 45px;
    cursor: pointer;

    &.active {
      color: #0b80ff;

      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        content: '';
        height: 3px;
        background: rgba(28, 134, 255, 1);
        overflow: hidden;
      }
    }

    &.disabled {
      color: rgba(204, 204, 204, 1);
    }
  }
}
</style>
